import { useGetSandboxWidget, useGetSandboxWidgetData } from "@/hooks";
import { WidgetRenderer } from "@/components/dashboard/widget-renderer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from 'react-i18next';

interface SandboxWidgetPreviewProps {
  widgetId: string;
}

export default function SandboxWidgetPreview({ widgetId }: SandboxWidgetPreviewProps) {
  const { t } = useTranslation();

  const {
    data: widgetData,
    isLoading: widgetLoading,
    error: widgetError,
  } = useGetSandboxWidget(widgetId);

  const {
    data: dataResponse,
    isLoading: dataLoading,
    error: dataError,
  } = useGetSandboxWidgetData(widgetId);

  const widget = widgetData?.data;
  const data = dataResponse?.data;

  const isLoading = widgetLoading || dataLoading;
  const error = widgetError?.message || dataError?.message;

  if (!widget) {
    return (
      <Card className="w-full max-w-md">
        <CardContent className="p-4">
          <div className="text-sm text-muted-foreground">
            {isLoading ? t('processManagement.loadingWidget') : t('processManagement.widgetNotFound')}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card data-no-autoscroll className="w-full max-w-md">
      <CardHeader className="pb-3">
        <CardTitle className="text-base truncate">
          {widget.title || t('processManagement.untitledWidget')}
        </CardTitle>
      </CardHeader>

      <CardContent className="pt-0">
        <div className="relative rounded-lg border bg-gradient-to-br from-gray-50 to-gray-100 h-64">
          <WidgetRenderer
            widget={widget}
            data={data}
            loading={isLoading}
            error={error}
            isPreview={false}
          />
        </div>
      </CardContent>
    </Card>
  );
}
